import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** More specific paths first so `:id` does not swallow `/new` or `/live`. */
const TITLE_ROUTES: { path: string; key: string }[] = [
  { path: "/", key: "dashboard.metaTitle" },
  { path: "/privacy", key: "legal.privacyMetaTitle" },
  { path: "/terms", key: "legal.termsMetaTitle" },
  { path: "/legal", key: "legal.privacyMetaTitle" },
  { path: "/login/link-invalid", key: "linkInvalid.metaTitle" },
  { path: "/login/forgot", key: "forgotPassword.metaTitle" },
  { path: "/login/redeem", key: "redeem.metaTitle" },
  { path: "/login", key: "auth.metaTitle" },
  { path: "/employee-login", key: "employeeLogin.metaTitle" },
  { path: "/set-password", key: "setPassword.metaTitle" },
  { path: "/projects/new", key: "projectsNew.metaTitle" },
  { path: "/projects/:id/live", key: "projectLive.metaTitle" },
  { path: "/projects/:id", key: "projectOverview.metaTitle" },
  { path: "/projects", key: "projectsList.metaTitle" },
  { path: "/employees", key: "employees.metaTitle" },
  { path: "/companies/:id", key: "companyDetail.metaTitle" },
  { path: "/companies", key: "companies.metaTitle" },
  { path: "/admin", key: "admin.metaTitle" },
  { path: "/festschreibung", key: "festschreibung.metaTitle" },
  { path: "/my/tracking/:projectId", key: "myTracking.metaProject" },
  { path: "/my/tracking", key: "myTracking.metaIndex" },
];

/** Updates `document.title` from the current route and locale. */
export function PageTitle() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const hit = TITLE_ROUTES.find((route) => matchPath({ path: route.path, end: true }, pathname));
    document.title = hit ? String(t(hit.key)) : String(t("notFound.metaTitle"));
  }, [pathname, t, i18n.language]);

  return null;
}
